"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mod10 = mod10;
exports.mod11 = mod11;
exports.isValidDate = isValidDate;
exports.sumDigits = sumDigits;
exports.getLastDigit = getLastDigit;
exports.countDigits = countDigits;
exports.replaceIf = replaceIf;
exports.getEnumValues = getEnumValues;
exports.isMobile = isMobile;
exports.sleep = sleep;
exports.isValidUrl = isValidUrl;
exports.isNumeric = isNumeric;
const dayjs = require("dayjs");
function mod10(number) {
    let len = number.length;
    let bit = 1;
    let sum = 0;
    let val;
    const arr = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];
    while (len) {
        val = parseInt(number.charAt(--len), 10);
        bit ^= 1;
        sum += bit ? arr[val] : val;
    }
    return sum && sum % 10 === 0;
}
function mod11(number) {
    let len = number.length;
    let sum = 0;
    let val;
    const weights = [1, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1];
    const arr = weights.splice(weights.length - len, weights.length - (weights.length - len));
    while (len) {
        val = parseInt(number.charAt(--len), 10);
        sum += arr[len] * val;
    }
    return sum && sum % 11 === 0;
}
function isValidDate(date, format) {
    return dayjs(date, format).format(format) === date;
}
function sumDigits(value) {
    return String(value)
        .split('')
        .map((num) => parseInt(num, 10))
        .reduce((acc, num) => acc + num);
}
function getLastDigit(value) {
    return parseInt(String(value).slice(-1), 10);
}
function countDigits(value) {
    if (typeof value !== 'string') {
        value = String(value);
    }
    return value
        .split('')
        .map((num) => parseInt(num, 10))
        .sort()
        .reduce((acc, num) => {
        acc[num] = typeof acc[num] === 'undefined' ? 1 : ++acc[num];
        return acc;
    }, {});
}
function replaceIf(num, value, replacement) {
    return num === value ? replacement : num;
}
function getEnumValues(value) {
    const keys = Object.keys(value);
    const isNumericEnum = keys.filter((k) => parseInt(k, 10) > 0).length > 0;
    if (isNumericEnum) {
        return Object
            .keys(value)
            .filter((item) => !isNaN(Number(item)))
            .map((k) => parseInt(k, 10));
    }
    return keys;
}
function isMobile() {
    return /Android|iPhone|iPad/i.test(navigator.userAgent);
}
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
function isValidUrl(url) {
    try {
        return Boolean(new URL(url));
    }
    catch (_err) {
        return false;
    }
}
function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
